"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const SvgSpacesMastheadTable = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: 60, height: 60 }, props),
    React.createElement("path", { d: "M43.4 22v-1H1v1h15v7H1v1h15v7H1v1h15v7.4h1V38h12v7.4h1V38h13.4v-1H30v-7h13.4v-1H30v-7h13.4zM29 37H17v-7h12v7zm0-8H17v-7h12v7z", style: {
            fill: "#b3b3b5",
        } }),
    React.createElement("path", { d: "M43 14v31H2V14h41m0-1H2c-.6 0-1 .4-1 1v31c0 .6.4 1 1 1h41c.6 0 1-.4 1-1V14c0-.6-.5-1-1-1z", style: {
            fill: "#6e6f72",
        } })));
const Memo = (0, react_1.memo)(SvgSpacesMastheadTable);
exports.default = Memo;
//# sourceMappingURL=SpacesMastheadTable.js.map